import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const BusinessCSIOMpoiWrapper = Loadable(
  lazy(() =>
    import(
      "./BusinessCSIOMpoiWrapper"
    ).then(({ BusinessCSIOMpoiWrapper }) => ({
      default: BusinessCSIOMpoiWrapper,
    }))
  )
);
const BusinessMpoiWrapper = Loadable(
  lazy(() =>
    import("./BusinessMpoiWrapper").then(
      ({ BusinessMpoiWrapper }) => ({
        default: BusinessMpoiWrapper,
      })
    )
  )
);

export const BusinessCSIOMpoiWrapperRouter = [
  {
    path: `/business-policy/:customerId/csio-mpoi/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessCSIOMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/csio-mpoi/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/csio-mpoi/:customerPolicyId/manage/:premiumNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
];
